import * as AdminApi from './admins'
import * as AuthApi from './auth'
import * as BookingsApi from './bookings'
import * as FaqApi from './faq'
import * as LogApi from './log'
import * as MailTemplatesApi from './mailTemplates'
import * as OperatorsApi from './operators'
import * as StationsApi from './stations'
import * as UsersApi from './users'
import * as NotifyApi from './notify'
import * as FirmwareApi from './firmwares'
import * as SystemApi from './system'
import * as SystemLogsApi from './systemLogs'

export const apiBase = process.env.BACKEND_BASE_URL as string

export default {
  AdminApi,
  AuthApi,
  BookingsApi,
  FaqApi,
  LogApi,
  MailTemplatesApi,
  OperatorsApi,
  StationsApi,
  UsersApi,
  NotifyApi,
  FirmwareApi,
  SystemApi,
  SystemLogsApi
}
